import React from 'react';
import { isEmpty } from 'lodash';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { SelectField } from '@redshelf/redshelf-ui';
import TermService from 'services/TermService';

import GET_TERMS_FOR_TERM_SWITCHER from './getTermsForTermSwitcher.graphql';

import { ROUTER } from 'constants';

const termService = new TermService();

// TODO: This exposes a bug where the Term Switcher is firing twice on load a selectedTerm
// existed but no longer exists in the drop down options because components are already firing
// on with the previous selectedTermId before it's reset here. This is obvious against mock data
// since every page load generates new terms, but less obvious in acceptance or production (I'm assuming)
// because the terms are a lot less likely to change between page loads, much less at all.
// This needs to be fixed so that queries relying on term id don't fire until it is verified the term in localstorage
// exists in the list of terms available to them.
const isSelectedTermInTermData = (selectedTermId, termData) => {
  const selectedTerm = termData.allTerms.edges.find(({ node: term }) => {
    return term.id === selectedTermId;
  });

  return !isEmpty(selectedTerm);
};

const TermSwitcher = ({ size, ...props }) => {
  const { id: selectedTermId } = termService.asReactiveVariable('selectedTerm');

  const { loading, error, data } = useQuery(GET_TERMS_FOR_TERM_SWITCHER);

  if (loading) {
    return <div>loading</div>;
  }

  if (error) {
    return <div>error: {error.message}</div>;
  }

  if (!data?.allTerms?.edges[0]?.node) {
    return <Navigate to={`${ROUTER.basename}/403`} />;
  }

  if (!selectedTermId || !isSelectedTermInTermData(selectedTermId, data)) {
    return termService.setSelectedTerm(data?.allTerms?.edges[0]?.node);
  }

  const terms = data.allTerms.edges.map(({ node: term }) => {
    return term;
  });

  const handleTermSwitcherChange = (event) => {
    const selectedTerm = terms.find((term) => {
      return term.id === event.target.value;
    });
    termService.setSelectedTerm(selectedTerm);
  };

  return (
    <SelectField
      value={selectedTermId}
      onChange={handleTermSwitcherChange}
      formFieldProps={{
        disabled: isEmpty(terms) || loading,
        id: 'term-switcher',
        label: 'Term',
        variant: 'outlined',
        size,
      }}
      {...props}
    >
      {isEmpty(terms) ? (
        <option>No available terms</option>
      ) : (
        terms.map((term) => {
          return (
            <option key={term.id} value={term.id}>
              {term.name}
            </option>
          );
        })
      )}
    </SelectField>
  );
};

export default TermSwitcher;
